<template>
	<ion-page>
		<ion-header>
			<ion-toolbar>
				<ion-title>Punkte einlösen</ion-title>
				<avatar-menu :show-points="true"></avatar-menu>
			</ion-toolbar>
		</ion-header>
		<ion-content :fullscreen="true" class="">
			<ion-header collapse="condense">
				<ion-toolbar>
					<ion-title size="large">Punkte einlösen</ion-title>
				</ion-toolbar>
			</ion-header>

			<h1>Hier kannst du in zukunft deine Punkte einlösen!</h1>

			<ExploreContainer name="Tab 1 page"></ExploreContainer>
		</ion-content>
	</ion-page>
</template>

<script lang="ts">
import {
	IonContent,
	IonHeader,
	IonPage,
	IonTitle,
	IonToolbar
} from '@ionic/vue';
import ExploreContainer from '@/components/ExploreContainer.vue';
import AvatarMenu from "@/components/menu/AvatarMenu.vue";
import ChallengeNews from "@/components/challenge/ChallengeNews.vue";

// import {System} from "@/services/system.service";

export default {
	name: 'RedeemPointsTab',
	components: {
		AvatarMenu,
		ExploreContainer,
		IonHeader,
		IonToolbar,
		IonTitle,
		IonContent,
		IonPage,
	},
	setup(props: any) {
		console.log(props) // { user: '' }

		return {}
	}
}
</script>

<style>
</style>